/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_contact_helper_messages_confirmation_missing_product = /** @type {(inputs: {}) => string} */ () => {
	return `Prosím upřesněte neobdržený produkt`
};

const da_contact_helper_messages_confirmation_missing_product = /** @type {(inputs: {}) => string} */ () => {
	return `Angiv venligst hvilket produkt du ikke har modtaget`
};

const de_contact_helper_messages_confirmation_missing_product = /** @type {(inputs: {}) => string} */ () => {
	return `Bitte geben Sie das fehlende Produkt an`
};

const en_contact_helper_messages_confirmation_missing_product = /** @type {(inputs: {}) => string} */ () => {
	return `Please specify the product not received`
};

const es_contact_helper_messages_confirmation_missing_product = /** @type {(inputs: {}) => string} */ () => {
	return `Por favor, indícanos el producto no recibido`
};

const fr_contact_helper_messages_confirmation_missing_product = /** @type {(inputs: {}) => string} */ () => {
	return `Merci de nous préciser le produit non reçu`
};

const hu_contact_helper_messages_confirmation_missing_product = /** @type {(inputs: {}) => string} */ () => {
	return `Kérjük, adj meg a be nem érkezett termék adatait`
};

const it_contact_helper_messages_confirmation_missing_product = /** @type {(inputs: {}) => string} */ () => {
	return `Indica il prodotto non ricevuto`
};

const nl_contact_helper_messages_confirmation_missing_product = /** @type {(inputs: {}) => string} */ () => {
	return `Geef aan welk product je niet hebt ontvangen`
};

const pl_contact_helper_messages_confirmation_missing_product = /** @type {(inputs: {}) => string} */ () => {
	return `Prosimy o podanie brakującego produktu`
};

const pt_contact_helper_messages_confirmation_missing_product = /** @type {(inputs: {}) => string} */ () => {
	return `Por favor, especifique o produto não recebido`
};

const sv_contact_helper_messages_confirmation_missing_product = /** @type {(inputs: {}) => string} */ () => {
	return `Vänligen ange vilken produkt som saknas`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const contact_helper_messages_confirmation_missing_product = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.contact_helper_messages_confirmation_missing_product(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("contact_helper_messages_confirmation_missing_product", locale)
	if (locale === "cs") return cs_contact_helper_messages_confirmation_missing_product(inputs)
	if (locale === "da") return da_contact_helper_messages_confirmation_missing_product(inputs)
	if (locale === "de") return de_contact_helper_messages_confirmation_missing_product(inputs)
	if (locale === "en") return en_contact_helper_messages_confirmation_missing_product(inputs)
	if (locale === "es") return es_contact_helper_messages_confirmation_missing_product(inputs)
	if (locale === "fr") return fr_contact_helper_messages_confirmation_missing_product(inputs)
	if (locale === "hu") return hu_contact_helper_messages_confirmation_missing_product(inputs)
	if (locale === "it") return it_contact_helper_messages_confirmation_missing_product(inputs)
	if (locale === "nl") return nl_contact_helper_messages_confirmation_missing_product(inputs)
	if (locale === "pl") return pl_contact_helper_messages_confirmation_missing_product(inputs)
	if (locale === "pt") return pt_contact_helper_messages_confirmation_missing_product(inputs)
	return sv_contact_helper_messages_confirmation_missing_product(inputs)
};
export { contact_helper_messages_confirmation_missing_product as "contact.helper_messages.confirmation.missing_product" }